import cx from 'classnames'
import { Instrument, InstrumentStatus } from '~/common.interface'
import GenericInstrumentBody from './GenericInstrumentBody'
import GenericInstrumentPage from './GenericInstrumentPage'
import cs from './single_transfer_station_instrument_page.scss'

interface SingleTransferStationInstrumentPageProps {
  className?: string
  instrument: Instrument
  status: InstrumentStatus
  live?: boolean
}

const SingleTransferStationInstrumentPage = ({
  className,
  status,
  live,
  instrument,
}: SingleTransferStationInstrumentPageProps) => {
  const renderBodyContents = () => {
    return (
      <GenericInstrumentBody
        instrument={instrument}
        views={['transfer_stations', 'list']}
        defaultView='transfer_stations'
        className={cs.bodyContents}
      />
    )
  }

  return (
    <div className={cx(className, cs.singleTransferStationInstrumentPage)}>
      <GenericInstrumentPage
        instrument={instrument}
        bodyContents={renderBodyContents()}
        status={status}
        live={live}
        className={cs.genericInstrumentPage}
      />
    </div>
  )
}

export default SingleTransferStationInstrumentPage
